import React, {useContext} from 'react';

const EmployeeContext = React.createContext();

export const useEmployeeContext = () => useContext(EmployeeContext);

export default EmployeeContext;
